import React, { Component } from 'react';
import LOOKUP from 'constants/lookup';
import DialogInput from 'screens/components/advanced/DialogInput';
import TimePickerInput from 'screens/components/basic/TimePickerInput';
import Button from 'screens/components/basic/Button';
import DialogHeader from 'screens/components/basic/DialogHeader';
import GenericTable from 'screens/components/advanced/GenericTable';
import moment from 'moment';

const componentName = 'ScheduleSetTimeSlots'

class ScheduleSetTimeSlotsDialog extends Component {

    constructor(props) {
        super(props);

        this.state = {
            
        };
    }


    addNewTimeSlot = () => {
        this.props.addNewTimeSlot();
    }

    removeTimeSlot = (id) => {
        this.props.removeTimeSlot(id);
    }
    
    mapCustomTimeSlots = (customTimeSlots) => {
        return ( 
            customTimeSlots ?
            customTimeSlots.map((item) => {
                return {
                    StartShift: moment(item.startShift).format("hh:mm A"),
                    EndShift: moment(item.endShift).format("hh:mm A"),
                    Delete: <Button type="IconDeleteButton"
                                className="IconDeleteButton"
                                onTouchTap={() => this.removeTimeSlot(item.id)} />
                }
            }) : []
        )
    }

    render(){
    
        const p = this.props;   
        const listColumns = [
            {key: "StartShift", label: "Start Shift"},
            {key: "EndShift", label: "End Shift"},
            {key: "Delete", label: "Delete"}
        ]   

        const actions = [
            <Button
                type="CancelButton"
                className="btn-space btnCleanSearch"
                label={LOOKUP.common.cancel.text}
                secondary={true}
                onTouchTap={this.props.handleDiag}
            />,
            <Button name="SaveButton"
                className="pull-right btnNewBrandPOS"
                label="Confirm"
                primary={true}
                onTouchTap={this.props.handleDiag}
            />,
        ]


        return(
            <div>
                <DialogInput
                    title={<DialogHeader text="Set Up Time Slots" />}
                    modal={true}
                    actions = {actions}
                    className={"schedule_dialog"}
                    open={p.open}
                    autoScrollBodyContent={true}
                >
                <h4>Add a new customized time slot:</h4>
                <div className="row m-0">
                    <div className="col-lg-4 col-md-4 col-sm-4">
                        <TimePickerInput
                            id="inputStartTime"
                            name={`${componentName}Start`}
                            floatingLabelText="Start Time"
                            label="Start Time"
                            hintText="Start Time"
                            fullWidth={true}
                        />
                    </div>
                    <div className="col-lg-4 col-md-4 col-sm-4">
                        <TimePickerInput
                            id="inputEndTime"
                            name={`${componentName}End`}
                            floatingLabelText="End Time"
                            label="End Time"
                            hintText="End Time"
                            fullWidth={true}
                        />
                    </div>
                    <div className="col-lg-4 col-md-4 col-sm-4 pt-2">
                    <Button name="AddButton"
                        className="pull-right align-bottom btnNewBrandPOS"
                        label="Add"
                        primary={true}
                        onTouchTap={this.addNewTimeSlot}
                    />  
                    </div>
                </div>
                <GenericTable
                    className="table_centerText tableHeaderTxt mt-2"
                    stripedRows={true}
                    columns={listColumns}
                    rows={this.mapCustomTimeSlots(this.props.customTimeSlots)}
                />                    
                    
                </DialogInput>
            </div>
        )
    }
}


export default ScheduleSetTimeSlotsDialog;